import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  ClientData,
  SelectedClientData,
} from '../api/models/select-client.model';
import { CartService } from '../cart/cart.service';

@Injectable({
  providedIn: 'root',
})
export class SelectClientService extends CartService {
  hasClient$$ = new BehaviorSubject(false);
  updateData$$ = new BehaviorSubject(false);
  clientChanged$$ = new Subject<void>();
  totalItemsCart$$ = new BehaviorSubject<number>(0);
  constructor() {
    super();
  }

  setCurrentClientInSessionStorage(
    selectClientData: SelectedClientData,
    MAX_DESCONTO?: number,
  ) {
    this.keyCart = selectClientData.selectClient;

    const clientData = {
      id: selectClientData.selectClient,
      filial: selectClientData.selectFilial,
      data: selectClientData.selectClientData,
      formaDePagamento: selectClientData.selectPagamento,
      transportadora: selectClientData.selectTransportadora,
      limiteDeCredito: 0,
      origemVenda: selectClientData.selectOrigemVenda,
      planoDePagamento: selectClientData.selectPrazo,
      formaDeEntrega: selectClientData.selectEntrega,
      statusCreditario: '',
      vendedor: selectClientData.selectVendedor,
      endereco: selectClientData.selectAddress,
      tipoVenda: selectClientData.selectTipoVenda,
      indication: selectClientData.selectIndication,
      selectedturno: selectClientData.Selectedturno,
    } as ClientData;

    this.storage.setItem(`${this.keyCart}`, JSON.stringify(clientData));

    const cartStringify = this.storage.getItem(`${this.keyCart}-cart`);
    const cart = cartStringify && JSON.parse(cartStringify);

    if (cart) {
      const newCart = cart.map(
        (item: {
          desconto: number;
          filial: number;
          id: number;
          image: string;
          multiplo: string;
          observacao: { observacao: string; ambiente: string };
          olderPrice: number;
          preco: number;
          precoComDesconto: number;
          retiradaImediata: boolean;
          produto: string;
          qtd: number;
          remove: boolean;
          stock: number;
          subTotal: number;
        }) => {
          const discount = item.olderPrice * MAX_DESCONTO!;
          item.preco = +(item.olderPrice + discount).toFixed(2);
          return item;
        },
      );

      this.storage.setItem(`${this.keyCart}-cart`, JSON.stringify(newCart));
    }
  }

  setCliente(cliente: ClientData) {
    this.storage.setItem(`${this.keyCart}`, JSON.stringify(cliente));
    this.storage.setItem('filial', cliente.filial.toString());
  }

  getCliente(key = this.keyCart): ClientData | null {
    const cliente = this.storage.getItem(`${key}`);

    return cliente && JSON.parse(cliente);
  }

  getCurrentClientInSessionStorage(): ClientData {
    return JSON.parse(this.storage.getItem(`${this.keyCart}`) || '{}');
  }

  resetClient() {
    this.resetCart();
    this.storage.removeItem(`${this.keyCart}`);
    this.storage.removeItem(`lastCliente`);
    this.hasClient$$.next(false);
    this.updateData$$.next(false);
    this.clientChanged$$.next();
  }
}
